import { sei as viemSei } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const sei = {
  displayName: 'Sei',
  runtime: 'evm',
  viemChain: viemSei,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'sei' },
    qnStreams: {
      networkKey: 'sei-mainnet',
    },
    pimlico: { chainSlug: 'sei' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
